/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlZeroDayAlertResolutionStatus } from './ControlZeroDayAlertResolutionStatus';
import {
    ControlZeroDayAlertResolutionStatusFromJSON,
    ControlZeroDayAlertResolutionStatusFromJSONTyped,
    ControlZeroDayAlertResolutionStatusToJSON,
} from './ControlZeroDayAlertResolutionStatus';

/**
 * 
 * @export
 * @interface ControlResolveZeroDayAlertRequest
 */
export interface ControlResolveZeroDayAlertRequest {
    /**
     * 
     * @type {ControlZeroDayAlertResolutionStatus}
     * @memberof ControlResolveZeroDayAlertRequest
     */
    resolution_status: ControlZeroDayAlertResolutionStatus;
}

/**
 * Check if a given object implements the ControlResolveZeroDayAlertRequest interface.
 */
export function instanceOfControlResolveZeroDayAlertRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resolution_status" in value;

    return isInstance;
}

export function ControlResolveZeroDayAlertRequestFromJSON(json: any): ControlResolveZeroDayAlertRequest {
    return ControlResolveZeroDayAlertRequestFromJSONTyped(json, false);
}

export function ControlResolveZeroDayAlertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResolveZeroDayAlertRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resolution_status': ControlZeroDayAlertResolutionStatusFromJSON(json['resolution_status']),
    };
}

export function ControlResolveZeroDayAlertRequestToJSON(value?: ControlResolveZeroDayAlertRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resolution_status': ControlZeroDayAlertResolutionStatusToJSON(value.resolution_status),
    };
}

